export const SOCIAL_LINKS_ACTION = 'SOCIAL_LINKS_ACTION';
export const SOCIAL_LINKS_SUCCESS_ACTION = 'SOCIAL_LINKS_SUCCESS_ACTION';
export const SOCIAL_LINKS_FAILURE_ACTION = 'SOCIAL_LINKS_FAILURE_ACTION';
